import { Stack } from '@mui/material'
import type { FC } from 'react'

import { CarouselLoading, unit } from '@hcr/ui'

import { BookingOverviewCompactLoading } from '../common'

import { LayoutHome } from './common'

export const HomeLoading: FC = () => {
  return (
    <LayoutHome
      content={<CarouselLoading slidesMargin={unit(3)} />}
      header={
        <Stack gap={unit(4)}>
          <BookingOverviewCompactLoading />
        </Stack>
      }
      imageUrl={''}
    />
  )
}
